module.exports = __webpack_public_path__ + "static/media/WDTJSSAEFTMALC1.f0271e23.png";